import { OfferAccess, UserRequestStatus } from "types/enums.ts";

import OfferData = App.Data.OfferData;

interface FilterOffersByAccessParams {
    offers: OfferData[];
    userId?: string;
    hasOfferViewAccessUnrestrictedPermission: boolean;
}

export const filterOffersByAccess = ({
    offers,
    userId,
    hasOfferViewAccessUnrestrictedPermission,
}: FilterOffersByAccessParams): OfferData[] => {
    return offers.filter((offer) => {
        switch (offer.access) {
            case OfferAccess.Public:
                return true;
            case OfferAccess.Restricted: {
                if (hasOfferViewAccessUnrestrictedPermission) {
                    return true;
                }
                const isAffiliateInOffer = offer.affiliates?.some(
                    (affiliate) => affiliate.id === userId
                );
                const lastRequest = offer.user_requests
                    ?.filter((request) => request.user_id === userId)
                    ?.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())[0];
                return isAffiliateInOffer && lastRequest?.status === UserRequestStatus.Accepted;
            }
            case OfferAccess.Private:
                return hasOfferViewAccessUnrestrictedPermission;
            default:
                return false;
        }
    });
};
